module.exports = __webpack_public_path__ + "static/img/376162cb.svg";